<template>
  <div class="detalle-saldo">
    <b-row class="mb-2 ml-2">
      <span class="total-mercancia">Billete</span>
      <span class="total-mercancia">Moneda</span>
    </b-row>

    <b-row class="mb-3 ml-2">
      <span class="total-mercancia-value">{{ filterNumber(saldo.numBilletes, 2) }}</span>
      <span class="total-mercancia-value">{{ filterNumber(saldo.numMonedas, 2) }}</span>
    </b-row>

    <b-row>
      <b-col>
        <b-table
          v-if="detalles"
          :fields="visibleFields"
          :items="detalles"
          :empty-text="$t('label.noData')"
          hover
          ref="tableDetalleSaldos"
          show-empty
          small
          borderless
        />
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import VueFilters from "@/vue-filters";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { IConfColumnaPais, IDetallesSaldo, IField, ISaldo } from "@/entities";
import { IColumnaResponse } from "@/services";

@Component({
  name: "detalle-saldo",
  mixins: [VueFilters],
})
export default class DetalleSaldo extends Vue {
  @Prop() public saldo!: ISaldo;
  @Prop({ required: true }) columnsConfig!: IColumnaResponse;

  @Action("fetchSaldoDetalle") fetchDetalle!: (id: number) => Promise<IDetallesSaldo[] | undefined>;

  @Action("setLoading") setLoading!: (loading: boolean) => void;

  detalles: IDetallesSaldo[] | null = null;

  get fields(): IField[] {
    const visibleKeys = this.columnsConfig?.codColumna?.split(",").filter((s) => s !== "") || [];
    let columnas: IField[] = [];
    this.columnsConfig.columnas?.forEach((column: IConfColumnaPais) => {
      columnas.push({
        key: column.keyFront,
        label: this.$t("label." + column.codColumna).toUpperCase(),
        sortable: true,
        thClass: "table-header-detail",
        tdClass: "table-cell-detail",
        thStyle: column.widthFront ? { width: column.widthFront } : {},
        visible: this.isVisible(visibleKeys, column.codColumna),
        aux: false,
        code: column.codColumna,
        formatter: (value: any): string => {
          if (column.formatType == "Number") {
            return this.filterNumber(value, 2);
          }
          return value;
        },
      });
    });
    return columnas;
  }

  isVisible(visibleKeys: string[], column: string): boolean {
    return !visibleKeys.length || !!visibleKeys.find((key) => key === column);
  }

  get visibleFields(): IField[] {
    return this.fields.filter((item) => item.visible);
  }

  constructor() {
    super();
  }
  mounted(): void {
    this.fetch();
  }
  async fetch(): Promise<void> {
    const aux = await this.fetchDetalle(this.saldo.id);
    if (aux) {
      this.detalles = aux;
    }
  }
}
</script>

<style lang="scss" scoped>
.total-mercancia {
  width: 120px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #979797;
}

.total-mercancia-value {
  width: 120px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}
</style>
